// User-friendly error messages for Firebase authentication errors
export const getAuthErrorMessage = (error: any): string => {
    const errorCode = error.code;

    switch (errorCode) {
        // Sign In Errors
        case 'auth/invalid-credential':
        case 'auth/wrong-password':
        case 'auth/user-not-found':
            return 'Invalid email or password. Please check your credentials and try again.';

        case 'auth/invalid-email':
            return 'Please enter a valid email address.';

        case 'auth/user-disabled':
            return 'This account has been disabled. Please contact support.';

        case 'auth/too-many-requests':
            return 'Too many failed attempts. Please try again later.';

        case 'auth/network-request-failed':
            return 'Network error. Please check your internet connection and try again.';

        // Sign Up Errors
        case 'auth/email-already-in-use':
            return 'An account with this email already exists. Please try signing in instead.';

        case 'auth/weak-password':
            return 'Password is too weak. Please choose a stronger password.';

        // Password Reset Errors
        case 'auth/user-not-found':
            return 'No account found with this email address.';

        // Generic fallback
        default:
            return 'Something went wrong. Please try again or contact support if the problem persists.';
    }
};

// Validation error messages
export const getValidationErrorMessage = (field: string, value: any): string => {
    switch (field) {
        case 'password':
            if (!value) return 'Password is required.';
            if (value.length < 6) return 'Password must be at least 6 characters long for security.';
            return '';

        case 'confirmPassword':
            return 'Passwords do not match. Please make sure both password fields are identical.';

        case 'email':
            if (!value) return 'Email address is required.';
            if (!/\S+@\S+\.\S+/.test(value)) return 'Please enter a valid email address.';
            return '';

        case 'displayName':
            if (!value) return 'Full name is required.';
            if (value.length < 2) return 'Please enter your full name.';
            return '';

        default:
            return '';
    }
};
